<div class="contents">
    <div class="dm-page-content mb-25 page-report">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="page-header">
                        <div class="left-area">
                            <span class="title">Relatórios</span>
                            <span class="sub-title">Emitir relatórios</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="actionsTop col-12">
            <p-select
                [options]="options"
                [(ngModel)]="selectedOption"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione uma opção"
                class="w-full md:w-20rem">
            </p-select>
        </div>
        <app-report-documentos *ngIf="currentOption === 'documentos'"></app-report-documentos>
        <app-report-estudantes *ngIf="currentOption === 'estudantes'"></app-report-estudantes>
        <app-report-profissionais *ngIf="currentOption === 'profissionais'"></app-report-profissionais>
        <app-report-vagas *ngIf="currentOption === 'vagas'"></app-report-vagas>
    </div>
</div>